import * as t from 'io-ts';

export const Empty = t.type({});
export type Empty = t.TypeOf<typeof Empty>;
export const Faq = t.type({
  question: t.string,
  answer: t.string,
});
export type Faq = t.TypeOf<typeof Faq>;

export const Breadcrumb = t.type({
  redirectionUrl: t.string,
  displayString: t.string,
});

export type Breadcrumb = t.TypeOf<typeof Breadcrumb>;

export const PopularOperator = t.type({
  operatorName: t.string,
  seoUrl: t.union([t.string, t.null]),
});
export const Usp = t.type({
  id: t.number,
  created: t.string,
  modified: t.string,
  uspTitle: t.string,
  uspDescription: t.string,
  logoUrl: t.string,
});
export type Usp = t.TypeOf<typeof Usp>;

export const Template = t.type({
  created: t.union([t.string, t.undefined, t.null]),
  modified: t.union([t.string, t.undefined]),
  id: t.union([t.number, t.undefined]),
  templateName: t.union([t.string, t.undefined]),
  metaTitle: t.string,
  metaDescription: t.union([t.string, t.undefined]),
  metaKeywords: t.union([t.string, t.undefined]),
  analytics: t.union([t.string, t.undefined]),
  noOfListings: t.union([t.undefined, t.number]),
  footerData: t.string,
  h1Title: t.string,
  descriptionInHtml: t.union([t.string, t.undefined]),
  breadcrumb: t.array(Breadcrumb),
  bannerDesktop: t.union([t.string, t.null, t.undefined]),
  bannerMobile: t.union([t.string, t.null, t.undefined]),
  sampleUrl: t.union([t.string, t.undefined]),
  subTitle: t.union([t.string, t.undefined]),
  externalJs: t.string,
  extraInfo: t.union([t.string, t.undefined]),
  faq: t.union([t.undefined, t.array(Faq)]),
  usps: t.union([t.undefined, t.array(Usp)]),
  localBusTemplate: t.union([t.boolean, t.undefined, t.null]),
});
export type Template = t.TypeOf<typeof Template>;

export const Route = t.type({
  name: t.string,
  url: t.union([t.string, t.null]),
});
export type Route = t.TypeOf<typeof Route>;

export const RtcRoutes = t.type({
  operatorName: t.string,
  rtcRoutes: t.array(Route),
});

export const TopOperators = t.type({
  operatorName: t.string,
  rating: t.number,
  numberOfRatings: t.number,
  seoUrl: t.union([t.string, t.null]),
});
export type TopOperators = t.TypeOf<typeof TopOperators>;

export const TopRoutes = t.type({
  distance: t.number,
  duration: t.string,
  route_id: t.union([t.null, t.number]),
  from_city_id: t.string,
  to_city_id: t.string,
  from_city_name: t.string,
  to_city_name: t.string,
  min_price: t.union([t.number, t.null]),
  popular_operators: t.union([t.array(PopularOperator), t.null]),
  boarding_points: t.union([t.array(t.string), t.null]),
  drop_points: t.union([t.array(t.string), t.null]),
  url_to_bus_listing: t.union([t.string, t.null]),
  seoUrl: t.union([t.string, t.null]),
});
export type TopRoutes = t.TypeOf<typeof TopRoutes>;
export const Offer = t.type({
  offerTitle: t.string,
  offerDescription: t.string,
  logoUrl: t.string,
});
export type Offer = t.TypeOf<typeof Offer>;

export const MySafetyHtmls = t.type({
  mySafetyUsp: t.union([t.string, t.null]),
});
export type MySafetyHtmls = t.TypeOf<typeof MySafetyHtmls>;

export const Routes = t.type({
  url: t.union([t.string, t.null]),
  sourceCityName: t.string,
  destinationCityName: t.string,
  name: t.union([t.string, t.undefined]),
});
export type Routes = t.TypeOf<typeof Routes>;

export const RouteCategory = t.type({
  url: t.string,
  sourceCityName: t.string,
  destinationCityName: t.string,
  categoryName: t.string,
});
export type RouteCategory = t.TypeOf<typeof RouteCategory>;

export const NameUrl = t.type({
  url: t.string,
  name: t.string,
});
export const Operators = NameUrl;
export type Operators = t.TypeOf<typeof Operators>;

export const Bus = t.type({
  id: t.number,
  operatorName: t.string,
  busType: t.string,
  doj: t.string,
  durationInMins: t.number,
  departureTimeStr: t.string,
  departureDate: t.string,
  arrivalTimeStr: t.string,
  arrivalDate: t.string,
  availableSeats: t.number,
  minFare: t.number,
  rating: t.union([t.null, t.number]),
  avlWindowSeats: t.number,
  noOfRatings: t.union([t.null, t.number]),
  desktopUrl: t.union([t.string, t.null]),
  serviceId: t.number,
  mwebUrl: t.union([t.string, t.null]),
  safetyPlusEnabled: t.boolean,
  socialDistancing: t.boolean,
});
export type Bus = t.TypeOf<typeof Bus>;

export const BusGroup = t.type({
  buses: t.array(Bus),
  groupName: t.string,
  groupImageUrl: t.union([t.string, t.undefined, t.null]),
});
export type BusGroup = t.TypeOf<typeof BusGroup>;

export const TopBusesFrom = t.type({
  noOfBuses: t.number,
  busGroups: t.union([t.array(BusGroup), t.undefined]),
  otherBusGroups: t.union([t.array(BusGroup), t.undefined]),
  categorizedBusGroups: t.union([t.array(BusGroup), t.undefined]),
});
export const CityDataForRoute = t.type({
  id: t.number,
  name: t.string,
  description: t.union([t.string, t.null]),
  url: t.string,
  code: t.string,
  cityBoardingPointsList: t.union([t.array(t.string), t.undefined]),
  cityDropPointsList: t.union([t.array(t.string), t.undefined]),
  otherRoutesFrom: t.array(Route),
  otherRoutesTo: t.array(Route),
  rtcRoutesSource: RtcRoutes,
  rtcRoutesDestination: RtcRoutes,
  cabsRoutes: t.array(Route),
  railsRoutes: t.array(Route),
  volvoACRoutes: t.array(Route),
  cityHotels: t.array(Route),
  cityHolidays: t.array(Route),
});
export type CityDataForRoute = t.TypeOf<typeof CityDataForRoute>;

export const TopOperatorRoute = t.type({
  operatorName: t.string,
  from_city_id: t.string,
  to_city_id: t.string,
  from_city_name: t.string,
  to_city_name: t.string,
  min_price: t.number,
  bus_types: t.array(t.string),
  desktop_url: t.string,
  mweb_url: t.string,
  duration: t.string,
});
export type TopOperatorRoute = t.TypeOf<typeof TopOperatorRoute>;

export const BusAmenities = t.type({
  name: t.string,
  url: t.string,
});
export type BusAmenities = t.TypeOf<typeof BusAmenities>;

export const BusReviews = t.type({
  passengerName: t.string,
  dateOfJourney: t.string,
  overallRating: t.number,
  subjectiveReview: t.string,
  id: t.string,
  gender: t.union([t.undefined, t.string]),
  sourceCity: t.string,
  destCity: t.string,
});

export type BusReviews = t.TypeOf<typeof BusReviews>;

export const LeaveIntentOffer = t.type({
  offerTitle: t.string,
  offerDescription: t.string,
});
export type LeaveIntentOffer = t.TypeOf<typeof LeaveIntentOffer>;

export const RtcData = t.type({
  acronym: t.string,
  friendlyName: t.string,
  fullName: t.string,
});
export type RtcData = t.TypeOf<typeof LeaveIntentOffer>;

export const QuickInformation = t.type({
  distance: t.number,
  duration: t.number,
  source: t.string,
  destination: t.string,
  earliestBus: t.string,
  lastBus: t.string,
  busNames: t.array(t.string),
  minPrice: t.string,
  maxPrice: t.string,
  averageRating: t.number,
  ratingCount: t.number,
});
export type QuickInformation = t.TypeOf<typeof QuickInformation>;

export const SeoOfferData = t.type({
  offerDescription: t.string,
  offerCode: t.string,
  offerAmount: t.number,
});
export type SeoOfferData = t.TypeOf<typeof SeoOfferData>;
